import { render, staticRenderFns } from "./ScriptureView.vue?vue&type=template&id=0201e907&scoped=true&"
import script from "./ScriptureView.vue?vue&type=script&lang=js&"
export * from "./ScriptureView.vue?vue&type=script&lang=js&"
import style0 from "./ScriptureView.vue?vue&type=style&index=0&id=0201e907&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201e907",
  null
  
)

export default component.exports